import { ConversationSession } from 'types'
import actionCreatorFactory from 'typescript-fsa'

const actionCreator = actionCreatorFactory('authors')

export const updateAuthors = actionCreator<
  Pick<ConversationSession, 'participants'>
>('UPDATE_AUTHORS')
